export default "__VITE_ASSET__CZ9U4$uG__"